/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { LOCALE_ID } from '@angular/core';

registerLocaleData(localePt);

providers: [
  { provide: LOCALE_ID, useValue: 'pt-BR' }
]

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
